import React from 'react';
import { Navigate } from 'react-router';
import Base from '../Base';
import SelectAsync from 'react-select/async';
import DatePicker from 'react-datepicker2';

export default class UnitCommuting extends Base {
    constructor(props) {
        super(props);
        this.state = {
            id: this.isNull(props.Id) ? this.defaultGuid() : props.Id,
            buildingUnitId: props.BuildingUnitId,
            caller: props.Caller,
            data: null,
            loading: true
        };
        this.keyDownFunction = this.keyDownFunction.bind(this);
    }
    componentWillUnmount() {
        this.removeKeyDown();
    }
    componentDidMount() {
        this.addKeyDown();
        this.httpPost("api/v1/building/unit/commuting/get", {
            id: this.getCurrentFormId(),
            buildingUnitId: this.state.buildingUnitId
        })
            .then(data => {
                if (data.status === -1) window.location.href = "/login";
                if (data.status === 1) {
                    this.setState({
                        data: data,
                        loading: false
                    })
                }
                else {
                    this.showErorrMessage(data.message);
                    this.setState({
                        loading: false
                    });
                }
            });
    }
    save(e) {
        if (!this.isNull(e)) e.preventDefault();
        if (this.isBlank(this.state.data.record.numberPeople)) this.state.data.record.numberPeople = "0";
        if (this.isBlank(this.state.data.record.roomCount)) this.state.data.record.roomCount = "0";

        this.httpPost("api/v1/building/unit/commuting/save", {
            id: this.state.id,
            buildingUnitId: this.state.buildingUnitId,
            enterTime: this.state.data.record.enterTime,
            exitTime: this.state.data.record.exitTime,
            type: this.state.data.record.type,
            enterDate: this.convertMomentToDb(this.state.data.record.enterDate),
            exitDate: this.convertMomentToDb(this.state.data.record.exitDate),
            mobile: this.state.data.record.mobile,
            name: this.state.data.record.name,
            note: this.state.data.record.note,
        })
            .then(data => {
                if (data.status === -1) window.location.href = "/login";
                if (data.status === 1) {
                    this.showSuccessMessage("اطلاعات با موفقیت ذخیره شد");
                    this.state.caller.refreshData();
                    this.closeMe();
                }
                else {
                    this.showErorrMessage(data.message);
                    this.setState({
                        loading: false
                    });
                }
            });
    }
    renderForm() {
        return <div className="modal fade listModal in show" tabIndex="-1" role="dialog">
            <div className="modal-backdrop fade in" style={{ "height": "100%" }} onClick={e => this.closeMe()}></div>
            <div className="modal-dialog ui-draggable">
                <div className="modal-content">
                    <div className="modal-body" style={{ "padding": "0" }}>
                        <div className="modal-header modal-header-info">
                            <button type="button" className="close" onClick={e => this.closeMe()} aria-label="Close"><span aria-hidden="true">×</span></button>
                            <h4 className="modal-title">
                                {this.state.data.record.id !== this.defaultGuid() ? "ویرایش اطلاعات ورود/خروج" : "افزودن ورود/خروج جدید"}
                            </h4>
                        </div>
                        <div className="modal-body">
                            <div className="container-fluid">
                                <div className="row">
                                    <div className="col-sm-2">
                                        <div className="form-group">
                                            <label for="name" className="title1">نام</label>
                                            <input type="text" defaultValue={this.state.data.record.name} onChange={e => this.state.data.record.name = e.target.value} autocomplete="off" type="text" className="form-control input-sm" />
                                        </div>
                                    </div>
                                    <div className="col-sm-2">
                                        <div className="form-group">
                                            <label for="name" className="title1">موبایل</label>
                                            <input defaultValue={this.state.data.record.mobile} onChange={e => this.state.data.record.mobile = e.target.value} autocomplete="off" type="text" className="form-control input-sm" />
                                        </div>
                                    </div>
                                    <div className="col-sm-1">
                                        <div className="form-group">
                                            <label for="name" className="title1">نوع</label>
                                            <select defaultValue={this.state.data.record.type} onChange={e => this.state.data.record.type = parseInt(e.target.value)} autocomplete="off" className="form-control input-sm">
                                                <option value="1">مالک</option>
                                                <option value="2">مستاجر</option>
                                                <option value="3">مهمان</option>
                                            </select>
                                        </div>
                                    </div>
                                    <div className="col-sm-2">
                                        <div className="form-group">
                                            <label for="name" className="title1">تاریخ ورود</label>
                                            <DatePicker
                                                inputReadOnly={false}
                                                className="form-control persian-date ltr"
                                                placeholder={"تاریخ"}
                                                isGregorian={false}
                                                showTodayButton={true}
                                                timePicker={false}
                                                onChange={(e) => { this.state.data.record.enterDate = e }}
                                                value={this.getFormatedDateForDatePicker(this.state.data.record.enterDate)}
                                            />
                                        </div>
                                    </div>
                                    <div className="col-sm-1">
                                        <div className="form-group">
                                            <label for="name" className="title1">زمان ورود</label>
                                            <input defaultValue={this.state.data.record.enterTime} onChange={e => this.state.data.record.enterTime = e.target.value} autocomplete="off" type="time" className="form-control input-sm" />
                                        </div>
                                    </div>
                                    <div className="col-sm-2">
                                        <div className="form-group">
                                            <label for="name" className="title1">تاریخ خروج</label>
                                            <DatePicker
                                                inputReadOnly={false}
                                                className="form-control persian-date ltr"
                                                placeholder={"تاریخ"}
                                                isGregorian={false}
                                                showTodayButton={true}
                                                timePicker={false}
                                                onChange={(e) => { this.state.data.record.exitDate = e }}
                                                value={this.getFormatedDateForDatePicker(this.state.data.record.exitDate)}
                                            />
                                        </div>
                                    </div>
                                    <div className="col-sm-1">
                                        <div className="form-group">
                                            <label for="name" className="title1">زمان خروج</label>
                                            <input defaultValue={this.state.data.record.exitTime} onChange={e => this.state.data.record.exitTime = e.target.value} autocomplete="off" type="time" className="form-control input-sm" />
                                        </div>
                                    </div>
                                    <div className="col-sm-12">
                                        <div className="form-group">
                                            <label for="name" className="title1">توضیحات</label>
                                            <input defaultValue={this.state.data.record.note} onChange={e => this.state.data.record.note = e.target.value} autocomplete="off" type="text" className="form-control input-sm" />
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="modal-footer">
                            <button type="button" className="btn btn-dim btn-outline-light" onClick={e => this.closeMe()}>انصراف</button>
                            <button type="submit" onClick={e => this.save(e)} className="btn btn-success">
                                ذخیره
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    }
    render() {
        if (!this.isBlank(this.state.redirect)) return <Navigate to={this.state.redirect} />

        let contents = this.state.loading ? this.renderLoading() :
            [
                this.state.lockScreen === 1 && this.lockScreen(),
                this.getGlobalContainer(),
                this.renderForm()
            ];

        return contents;
    }
}